import { TextField, ToggleButton } from '@mui/material';
import { styled } from '@mui/material/styles';

/** The small outlined input's height; toggle buttons match it so the row lines up. */
const CONTROL_HEIGHT = 40;

export const TextStyleToggleButton = styled(ToggleButton)({
  height: CONTROL_HEIGHT,
  width: CONTROL_HEIGHT,
});

export const TextStyleSizeField = styled(TextField)({
  width: 110,
  '& .MuiInputBase-root': { height: CONTROL_HEIGHT },
});
